import { isElectron } from '../..';
import { loginProfileState, hostMatchmakingState } from '../../stores/shared';
// import { pollHosts } from '../../util/getHosts';
import { enableRemoteControl } from '../peers/remoteControl';
import { connect as remoteClientConnect } from '../remoteClientRealtime';
import { connect as hostConnect } from '../realtime';
import { requestQuotaLimits } from '../managers/outbound';
import { connect as nodeServiceConnect } from '../nodeService';
import { sendAnalytics } from '@playcastdotio/Analytics';
import { checkAttestationOnly } from '../../services/machineIdAttestationFlow';
import { serviceContainer } from '../../../services/ServiceContainer';

export const initializeLoginProfileEvents = () => {
  if (isElectron) {
    nodeServiceConnect();
    let cachedLoginState = loginProfileState.currentState;
    loginProfileState.addListener((state) => {
      if (state.hostAuthId && isElectron) {
        if (state.hostAuthId !== cachedLoginState.hostAuthId) {
          // Skip remote control in guest mode - guest instances don't need remote control
          const isGuestMode = hostMatchmakingState.currentState.guestAccount;
          if (!isGuestMode) {
            enableRemoteControl();
          } else {
            console.log('[Login Profile Events] Skipping remote control in guest mode');
          }
          requestQuotaLimits();
          hostConnect();

          // Check machine ID attestation status after Clerk authentication.
          // Skip in guest mode (no Clerk authentication).
          // Only checks existing attestation — never performs one. The Add PC
          // screen handles performing attestation when the user clicks.
          if (!isGuestMode && state.hostAuthId) {
            checkAttestationOnly(state.hostAuthId).catch((error) => {
              console.error('[Login Profile Events] Machine ID attestation check error:', error);
            });
          }
        }
        cachedLoginState = { ...state };
      }
    });
    if (loginProfileState.currentState.hostAuthId) {
      // Skip remote control in guest mode - guest instances don't need remote control
      const isGuestMode = hostMatchmakingState.currentState.guestAccount;
      if (!isGuestMode) {
        enableRemoteControl();
      } else {
        console.log('[Login Profile Events] Skipping remote control in guest mode');
      }
      requestQuotaLimits();
      hostConnect();

      // Check machine ID attestation status if already authenticated on startup.
      // Skip in guest mode (no Clerk authentication).
      if (!isGuestMode && loginProfileState.currentState.hostAuthId) {
        checkAttestationOnly(loginProfileState.currentState.hostAuthId).catch((error) => {
          console.error('[Login Profile Events] Machine ID attestation check error:', error);
        });
      }
    }
  } else {
    // Using this since previousState is the same twice before it updates
    // to prevent duplicate analytics events
    let lastSentHostAuthId: string | undefined = undefined;

    loginProfileState.addListener((authState, previousState) => {
      if (authState.accessToken && authState.hostAuthId && !isElectron) {

        // Only send analytics if hostAuthId is different from the last sent one
        if (authState.hostAuthId !== lastSentHostAuthId && authState.hostAuthId) {
          // User auth event for remote dashboard
          serviceContainer.analyticsManager.sendUserAuthenticatedEvent('remote');
          lastSentHostAuthId = authState.hostAuthId;
        }

        remoteClientConnect();
        // pollHosts();
        // if (listener) clearInterval(listener);
        // listener = setInterval(() => {
        //   pollHosts();
        // }, 10000);
      }
    });
  }
};
